import React, { useState } from "react";
import { scroller } from "react-scroll";
import { Collapse } from "reactstrap";
import styled from "styled-components";
import { Heading } from "../Heading";
import FiltersDropdown from "./FiltersDropdown";
import NavbarSecond from "./NavbarSecond";

export const StyledCollapse = styled(Collapse)`
  padding: 10px;
`;

export default () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleCollapse = () => {
    setIsOpen(!isOpen);
    window.setTimeout(
      () => scroller.scrollTo("header2", { duration: 100, smooth: true }),
      400
    );
  };
  return (
    <React.Fragment>
      <Heading>
        <NavbarSecond toggleCollapse={toggleCollapse} />
      </Heading>
      <StyledCollapse isOpen={isOpen} className="bg-dark p-4 text-light">
        <FiltersDropdown />
      </StyledCollapse>
    </React.Fragment>
  );
};
